<template>
 <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{$t('navigations.alert summary')}}</h2>
    </div>
 </div>
 <div class="wrapper wrapper-content">
    <div class="ibox-content mb-1 px-3 py-2">
      <div class="form-group row mb-1">
         <div class="row my-2 my-lg-0">
            <div class="col-2 form-group mb-md-0 pr-1">
                <label class="mb-0">{{$t('navigations.site code')}}</label>
                <select
                    class="form-select my-md-2 my-lg-0"
                    name="account"
                    placeholder="Site Code"
                    v-model="selectedSite"
                    @change="getpatients($event.target.value)"
                    >
                        <option selected value="">{{$t('navigations.all')}}</option>
                        <option
                          v-for="site in sites"
                          :key="site.siteID"
                          :value="site.siteID"
                        >
                          {{ site.siteCode }}
                        </option>
                </select>
          </div>
          <div class="col-2 form-group mb-md-0 pr-1">
            <label class="mb-0">{{$t('navigations.subject id')}}</label>
            <select
              class="form-select my-md-2 my-lg-0"
              v-model="selectedSubject"
            >
                <option selected value="">{{$t('navigations.all')}}</option>
                <option
                  v-for="patient in this.patients"
                  :key="patient.patientId"
                  :value="patient.patientId"
                >
                {{ patient.subjectId }}
              </option>
            </select>
          </div>
          <div class="col-2 form-group mb-md-0 pr-1">
            <label class="mb-0">{{$t('navigations.alert type')}}</label>
            <select
              class="form-select my-md-2 my-lg-0"
              v-model="selectedAlertType"
            >
                <option selected value="">{{$t('navigations.all')}}</option>
                <option 
                  v-for="option in alertTypes" 
                  :key="option.id" 
                  :value="option">{{ option }}
                </option>
            </select>
          </div>
          <div class="col-2 form-group mb-md-0 pr-1">
            <label class="mb-0">{{$t('navigations.status')}}</label>
            <select
              class="form-select my-md-2 my-lg-0"
              v-model="selectedStatus"
            >
                <option selected value="">{{$t('navigations.all')}}</option>
                 <option 
                    v-for="option in alertStatus" 
                    :key="option" 
                    :value="option">{{ option }}
                </option>
            </select>
          </div>
          <div class="col-2 form-group mb-md-0 pr-1">
            <label class="mb-0">{{$t('navigations.priority')}}</label>
            <select
              class="form-select my-md-2 my-lg-0"
              v-model="selectedPriority"
            >
                <option selected value="">{{$t('navigations.all')}}</option>
                <option selected value="Severe">{{$t('navigations.severe')}}</option>
                <option selected value="High">{{$t('navigations.high')}}</option>
                <option selected value="Critical">{{$t('navigations.critical')}}</option>
            </select>
          </div>
          <div class="col-2 form-group mb-md-0 pr-1">
            <label class="mb-0">{{$t('navigations.source')}}</label>
            <select
              class="form-select my-md-2 my-lg-0"
              v-model="selectedSource"
            >
                <option selected value="">{{$t('navigations.all')}}</option>
                <option selected value="Android App">{{$t('navigations.android app')}}</option>
                <option selected value="FHIR">{{$t('navigations.FHIR')}}</option>
                <option selected value="iOS App">{{$t('navigations.ios app')}}</option>
                 <option selected value="Web Browser">{{$t('navigations.web browser')}}</option>
            </select>
          </div>
           <div class="col-4 form-group mb-md-0 pr-1">
            <label class="mb-0">{{$t('navigations.form')}}</label>
            <select
              class="form-select my-md-2 my-lg-0"
              v-model="selectedForm"
            >
                <option selected value="">{{$t('navigations.all')}}</option>
                 <option 
                    v-for="option in templates" 
                    :key="option.templateId" 
                    :value="option.templateName">{{ option.templateName}}
                </option>
            </select>
          </div>
           <div class="col-3 form-group mb-md-0 pr-1">
            <label class="mb-0">{{$t('navigations.date from')}}</label>
            <input
              type="date"
              class="form-control my-md-2 my-lg-0"
              v-model="dateFrom"
           >
           </div>
          <div class="col-3 form-group mb-md-0 pr-1">
            <label class="mb-0">{{$t('navigations.date to')}}</label>
             <input
              type="date"
              class="form-control my-md-2 my-lg-0"
              v-model="dateTo"
           >
          </div>
          <div class="col-3 col-md-2 px-0 align-self-end">
            <span type="button"
              @click="listAudit()"
              class="save_btn w-100 align-self-end"
            >
              {{$t('navigations.search')}}
            </span>
          </div>
         </div>
      </div>
    </div>
    <div class="ibox-body">
        <div class="ibox-title style_2 d-flex justify-content-between">
          <h5 class="my-0">{{$t('navigations.alert list')}}</h5>
          <div class="d-flex align-items-center">
            <div
              class="position-relative align-self-center mr-3"
              aria-label="Upload subject file"
              tabindex="0"
            >
            <button 
              class="btn btn-sm btn-outline-primary py-0 mr-1"
               @click.prevent="exportDataPdf()">
              <i class="fa fa-file-pdf-o"></i> Export to pdf </button>

             <button 
                class="btn btn-sm btn-outline-primary py-0"
                @click.prevent="exporttoexcell()"
                ><i class="fa fa-file-excel-o"></i> Export to Excel </button>
            <!-- <button>
              <img
              width="17"
              height="17"
              class="cursor-pointer"
              src="../../assets/img/upload.png"
              @click.prevent="exporttoexcell()"
            />
            <div class="tool-tip">export to excel</div>
            </button> -->
            <!-- <button>
                <img
                  width="17"
                  height="17"
                  class="cursor-pointer"
                  src="../../assets/img/upload.png"
                  @click.prevent="exportDataPdf()"
                />
            <div class="tool-tip">export to pdf</div>
            </button> -->
            </div>
          </div>
        </div>
        <div class="ibox-content">
          <div class="text-center" v-if="showLoading === true">
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class=""
              alt="Waiting for login"
            />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>      
        <template  v-else>
          <div class="text-center" v-if="alertList.length==0">
            {{ $t('navigations.no data available') }}
          </div>
          <div v-else class="table-responsive">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                  <th> {{$t('navigations.site code')}}</th>
                  <th> {{$t('navigations.subject id')}}</th>
                    <th> {{$t('navigations.alert for')}}</th>
                  <th> {{$t('navigations.type')}}</th>
                  <th> {{ $t('navigations.status') }}</th>
                  <th> {{$t('navigations.message')}}</th>
                  <th> {{$t('navigations.triggered date')}}</th>
                  <th class="text-center"> {{$t('navigations.view')}}</th>
              </thead>
              <tbody>
                    <tr v-for="(alert,index) in alertList" :key="alert.id">
                      <td>{{ alert.siteCode }}</td>
                      <td>{{ alert.subjectCode }}</td>
                      <td>{{ alert.alertConfig.AlertFor }}</td>
                      <td>{{ alert.alertConfig.AlertType }}</td>
                      <td>{{ alert.status }}</td>

                      <td class="text_wrap">
                            <div v-if="!readTitleMore[index]" class="breakWord">
                              <span class="cursor-pointer">
                                {{ alert.message ? alert.message.substring(0, 20) : '' }}
                              </span>
                              <span 
                                class="cursor-pointer more-block" 
                                @click="showTitleMore(index)" 
                                v-if="alert.message && alert.message.length > 20"> ...More
                              </span>
                            </div>

                            <div v-if="readTitleMore[index]" class="breakWord">
                              <span class="cursor-pointer"> {{ alert.message }} </span>
                              <span 
                                class="cursor-pointer less-block" 
                                @click="showTitleLess(index)"
                              > Less
                              </span>
                            </div>
                      </td>

                      
                      <td>{{ filterDate(alert.createdAt) }}</td>
                      <td class="text-center">
                      <i
                        class="fa fa-eye editicon align-middle"
                        @click="viewAlertDetails(alert.id, 'active alerts')"
                      ></i>
                    </td>
                    </tr>
              </tbody>
            </table>
            <div class="col-md-12 d-flex justify-content-md-end px-0" v-if="alertList.length!=0">
              <VPagination
                v-model="currentPage"
                :pages="totalPage"
                :range-size="1"
                active-color="#ededed"
                @update:modelValue="loadPage"
              />
            </div>
          </div>
        </template>
        </div>
    </div>
 </div>
  <viewAlertDetailsPopup
    v-if="showAlertDetailsPopup"
    ref="viewPopup"
    :AlertId="alertId"
    :AlertType="alertType"
    @openQueryPopup="Openquerypopup(alertId)"
    @callViewModal="openAlertStatusPopup($event)"
    @closeModal="closeAlertDetailsPopup"
  />
</template>
<script src="./AlertSummary.js"></script>
<style scoped>
.more-block,
.less-block {
  font-size: 11px;
  color: #618bd7;
}
.text_wrap {
  display: table-cell; 
  max-width: 200px;
  width: 200px;
  vertical-align: top;
}

.breakWord {
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
}
</style>